/**
 * Loads a remote image into a blob: URL suitable for canvas-based cropping (needs CORS).
 * @param {string} imageUrl
 * @returns {Promise<string>} object URL — caller must revoke when done
 */
export async function fetchImageAsBlobUrl(imageUrl) {
  const res = await fetch(imageUrl, {
    mode: 'cors',
    credentials: 'omit',
    cache: 'no-store',
  });
  if (!res.ok) {
    throw new Error(`Could not load image (${res.status})`);
  }
  const blob = await res.blob();
  if (!blob.type.startsWith('image/')) {
    throw new Error('URL did not return an image');
  }
  return URL.createObjectURL(blob);
}
